const mediaQueries = {
  tablet: `@media(min-width:768px)`,
  desktop: `@media(min-width:1025px)`,
  bigDesktop: '@media(min-width:1200px)',
};

export default mediaQueries;
